import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form } from "shared/ui";

function PrivateTimeForm({ form, handleSubmit, disabled }) {
  const { t } = useTranslation("TravelLine");
  return (
    <Form form={form} onSubmit={handleSubmit} className="py-5">
      <Row className="my-5">
        <Form.DateTimePicker
          name="start_time"
          label={t("labels.start_date")}
          displayAs={Col}
          disabled={disabled}
        />
        <Form.DateTimePicker
          name="end_time"
          label={t("labels.end_date")}
          displayAs={Col}
          disabled={disabled}
        />
      </Row>
    </Form>
  );
}

export default PrivateTimeForm;
